
import { catchError, finalize, map, take, tap } from 'rxjs/operators';
import {
  Component,
  AfterContentInit,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormService } from '../../components/forms/form.service';
import { PlycaDataService } from '../../../services/plyca.service';
import { PaginationInfo, PaginationDTO } from '../../api/PaginationModel';
import {
  SearchSettingDTO,
  SearchSettingColumnDTO,
  MasterDataDTO,
  ActionTypeDTO, SearchResultDTO, ActionDefinitionResult, DossierDTO
} from '../../api/plyca-dtos';

import { UserPrefs, DossiersViewPrefs, DossiersViewPrefsV2 } from '../../api/UserPrefs-dto';

import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';

import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { SET_USERPREFS } from '../../store/userPrefs';
import { forkJoin, Observable, of, throwError } from '../../../../node_modules/rxjs';
import {
  HelpService,
  HelpType
} from '../../components/common/help/help.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { FieldConfig, SearchConfig } from '../../api/contract-notice-dto';
import * as lodash from 'lodash';
import { Configuration } from '../../conf/app.constants';
import { TranslateService } from '@ngx-translate/core';
import { PropertyService } from '../../properties/property.service';
import { DatePipe } from '@angular/common';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { ProfileService } from '../../../services/profile.services';
import { UserService } from '../../user.service';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { AppConfiguration } from '../../conf/app.configuration';
import { ActionService } from '../../actions/action.service';
import { ActionsProcessComponent } from '../../actions/actions.process.component';
import {
  ActionDefinitionDTO, ActionParameterDefinitionDTO, ActionResultDTO, ContractDTO,
  ProcessRegisterInfoDTO, ProcurementProjectDTO, ProjectEntityDTO, SearchActionResultDTO
} from '../../api/plyca-dtos-v2';
import { SelectItem, MenuItem } from 'primeng-lts/api';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { SearchSettingDTOModal, searchGenericComponent } from '../../components/search/searchGeneric.component';
import { TaskAssignmentComponent } from '../../tasks/taskAssignment/component/taskAssignment.component';
import { TaskAssignmentComponentConfig } from '../../tasks/taskAssignment/model/taskAssignment.model';

// declare var jQuery: any;

@Component({
  selector: 'dossiersView',
  templateUrl: 'dossiers-view.template.html', providers: [DatePipe, DialogService, UIService]
})
export class dossiersViewComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  aceptar: boolean;
  public tmpFiltros: any;
  dossiersLoaded = false;
  dossiers: any[];

  enableMasive = false;
  masiveAvailable = false;
  selectedDossiers: any[];

  pageInfo: PaginationInfo;
  urlBase: string;
  @ViewChild('dt')
  table: any;

  searchSettingsLoaded = false;
  searchSettings: SearchSettingDTO;


  useLastPendingTask = false;
  allAvailableColumns: any[];
  defaultVisibleColumns: any[] = [];
  invisibleColumns: any[] = [];
  visibleColumns: any[] = [];
  orderColumns: any[] = [];
  noOrderColumns: any[] = [];
  defaultOrderColumns: any[] = [];

  loaded = false;

  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  userPrefs: UserPrefs;
  _dossierViewPrefs: DossiersViewPrefs;

  // TIPO DE EXPEDIENTES QUE SE ESTA GESTIONANDO
  tipoExpediente: string;

  // variable de control para ver los filtros
  displayFiltersBar = false;
  filtersVisible = false;

  // referencia al formulario para capturar el foco
  @ViewChild('element') element: ElementRef;

  windowHash: string;
  windowHash1: string;

  selectColumnsVisible = false;
  mySortField: string;
  mySortOrder: number;

  public hideDossierCopy: boolean;



  VER_PREGUNTAS = false;
  calendarEnabled = true;
  VER_COPIAR = false;
  // Visibilidad de la ficha de gestión de acceso de usuarios a expedientes
  VER_ProjectEntityUserAuthorizationForm = false;
  // Visibilidad de la ficha de gestión de acceso de usuarios a expedientes para autorizaciones de tipo DACI
  VER_ProjectEntityUserAuthorizationFormDACI = false;
  VER_ReassignmentOption = false;

  primeCols = [];
  primeColOrden = -1;

  cliente: any;

  private actionIdChangeStatusSituation: string;
  private actionIdCloseTaxYear: string;
  private actionIdProcessRecordId: string;
  private processRegisterInfo: ProcessRegisterInfoDTO;
  private isVisibleCloseTaxYear = false;
  private isVisibleChangeSituationCloseTaxYear = false;
  enabledContractsReco: any;

  constructor(
    public dialogService: DialogService,
    private actionService: ActionService,
    protected appConfig: AppConfiguration,
    private router: Router,
    public plycaService: PlycaDataService,
    public uiService: UIService,
    public formService: FormService,
    public dossierService: DossierService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private datePipe: DatePipe,
    private configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    private translateService: TranslateService,
    private propertyService: PropertyService,
    private profileService: ProfileService,
    private waitService: WaitLoadingService,
    private userService: UserService
  ) {
    super();


    this.subscribe(this.store.select('userPrefs').pipe(take(1)),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;

        // inicializar la variable por si no viene en las preferencias
        if (!this.userPrefs) {
          this.userPrefs = new UserPrefs();
        }
        if (!this.userPrefs.dossiersViewPrefs) {
          this.userPrefs.dossiersViewPrefs = new DossiersViewPrefs();
        }
        if (!this.userPrefs.dossiersViewPrefsV2) {
          this.userPrefs.dossiersViewPrefsV2 = new DossiersViewPrefsV2();
        }
        // Para evitar tener que definir en el route una entrada por cada tipo de expediente tipo dossiersView/EXP, se crea una unica
        // parametrizada dossiersView/:tipoExpediente. Esta linea fuerza al route a que interprete que hay cambio si cambia el valor del
        // parametro. Sin este cambio una navegacion desde dossiersView/EXP a dossiersView/CONTRACTS no funcionaria bien
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;

        this.subscribe(
          // this.route.url.pipe(map(segment => this.tipoExpediente = segment[segment.length - 1].path)),
          this.route.params,
          (params) => {
            this.tipoExpediente = params['tipoExpediente'];
            // Cargar preferencias de gestion de la pantalla para este tipo de expediente.
            if (!this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente]) {
              // migrar las preferencias de exp a la nueva estructura
              if (this.tipoExpediente === 'EXP') {
                if (this.userPrefs.dossiersViewPrefs) {
                  this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente] = this.userPrefs.dossiersViewPrefs;
                  this.userPrefs.dossiersViewPrefs = undefined;
                } else {
                  this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente] = new DossiersViewPrefs();
                }
              } else {
                this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente] = new DossiersViewPrefs();
              }
            }
            this._dossierViewPrefs = this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente];



            // 1. FILTRO NO VER CANCELADOS POR DEFECTO EN EXPEDIENTES DE CONTRATACION
            if (this.tipoExpediente === 'EXP' && typeof this._dossierViewPrefs.filters['showCancelled'] !== undefined) {

              this._dossierViewPrefs.filters['showCancelled'] = '0<>nulo';
              this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_DOSSIER));

            } else if (this.tipoExpediente.includes('CONTRACTS')) {
              this.subscribe(this.helpService.showContextHelpObservable(HelpType.REG_CONTRACT));
            }

            // 2. Establecer filtros que se reciben por url
            this.subscribe(this.route.queryParams,
              params1 => {
                if (params1['TIPO_PROCEDIMIENTO']) {
                  this._dossierViewPrefs.filters['type'] =
                    params1['TIPO_PROCEDIMIENTO'];
                }
              });

            // sentido order por defecto
            this.primeColOrden = this._dossierViewPrefs.sentido;


            // Configuración de la pantalla EXP o CONTRATOS
            this.urlBase = this.appConfig.getValue('URL_' + this.tipoExpediente);
            if (this.tipoExpediente.includes('CONTRACTS')) {
              // CONTRATOS
              this.enabledContractsReco = this.appConfig.getValue('dossier-view.search.CONTRACTS_RECO');
            }
          }




        );
      });

    // Visibilidad de la ficha de gestión de acceso de usuarios a expedientes
    this.subscribe(this.propertyService.getProperty('Acceso_Usr'),
      (propertyValue_accesoUsr) => {
        console.log('propertyValue_accesoUsr', propertyValue_accesoUsr);
        if (propertyValue_accesoUsr) {
          propertyValue_accesoUsr = propertyValue_accesoUsr.replace(';', ','); // El método hasRoles espera una lista separada por ','
          this.VER_ProjectEntityUserAuthorizationForm = this.userService.hasRoles(propertyValue_accesoUsr);
        }
      });

    // Visibilidad de la ficha de gestión de acceso de usuarios a expedientes para autorizaciones de tipo DACI
    this.subscribe(this.propertyService.getProperty('Acceso_Usr.DACI'),
      (propertyValue_accesoUsrDACI) => {
        console.log('propertyValue_accesoUsr.DACI', propertyValue_accesoUsrDACI);
        if (propertyValue_accesoUsrDACI) {
          // El método hasRoles espera una lista separada por ','
          propertyValue_accesoUsrDACI = propertyValue_accesoUsrDACI.replace(';', ',');
          this.VER_ProjectEntityUserAuthorizationFormDACI = this.userService.hasRoles(propertyValue_accesoUsrDACI);
        }
      });
    this.subscribe(this.profileService.isReassignmentEnabled(),
      (prop) => {
        this.VER_ReassignmentOption = prop;
      });

    this.subscribe(
      forkJoin([
        this.propertyService.getProperty('OCULTAR_COPIAR_EXPTE', 'false'),
        this.propertyService.getProperty('VER_PREGUNTAS_LICITACION', '1')
      ])
      ,
      (result: any[]) => {

        this.hideDossierCopy = result[0] === 'true';
        this.VER_COPIAR = !this.hideDossierCopy && this.profileService.newDossierEnabled;


        this.VER_PREGUNTAS = result[1] === '1';




      }
    );
    this.setVisibleChangeSituationCloseTaxYear();
    this.setVisibleCloseTaxYear();
    this.calendarEnabled = true;
    if (this.appConfig.getValue('calendar.enabled.profiles') !== undefined
      && !this.userService.hasRoles(this.appConfig.getValue('calendar.enabled.profiles'))
    ) {
      this.calendarEnabled = false;
    }

    this.subscribe(
      forkJoin([
        this.plycaService.query<ActionDefinitionDTO>(this.configuration.ACTIONDEFINICION_SERVICE_URL
          , {
            actionObjType: 'PROCUREMENTPROJECT',
            id: 'LEGANES_CHANGE_STATUS_SITUATION_CLOSE_TAX_YEAR'
          }
        ).pipe(
          catchError((error: any) =>
            this.translateService.instant('MultiTaskAction.Errors.Action')),
          tap((result: PaginationDTO<ActionDefinitionDTO>) => {
            if (!result || !result.content || result.content.length === 0) {
              // this.subscribe(this.showErrorAndClose(undefined, this.translateService.instant('MultiTaskAction.Errors.NoAction')));
              this.translateService.instant('MultiTaskAction.Errors.NoAction')
            } else {
              this.actionIdChangeStatusSituation = result.content[0].identifier;
            }
          })
        )
        ,
        this.plycaService.query<ActionDefinitionDTO>(this.configuration.ACTIONDEFINICION_SERVICE_URL
          , {
            actionObjType: 'USER',
            id: 'CLOSE_TAXYEAR'
          }
        ).pipe(
          catchError((error: any) =>
            this.translateService.instant('MultiTaskAction.Errors.Action')),
          tap((result: PaginationDTO<ActionDefinitionDTO>) => {
            if (!result || !result.content || result.content.length === 0) {
              // this.subscribe(this.showErrorAndClose(undefined, this.translateService.instant('MultiTaskAction.Errors.NoAction')));
              this.translateService.instant('MultiTaskAction.Errors.NoAction')
            } else {
              this.actionIdCloseTaxYear = result.content[0].identifier;
            }
          })
        )
        ,
        this.plycaService.query<ActionDefinitionDTO>(this.configuration.ACTIONDEFINICION_SERVICE_URL
          , {
            actionObjType: 'USER',
            id: 'LEGANES_REGISTRAR_PROCESO'
          }
        ).pipe(
          catchError((error: any) =>
            this.translateService.instant('MultiTaskAction.Errors.Action')),
          tap((result: PaginationDTO<ActionDefinitionDTO>) => {
            if (!result || !result.content || result.content.length === 0) {
              // this.subscribe(this.showErrorAndClose(undefined, this.translateService.instant('MultiTaskAction.Errors.NoAction')));
              this.translateService.instant('MultiTaskAction.Errors.NoAction')
            } else {
              this.actionIdProcessRecordId = result.content[0].identifier;
            }
          })
        )
      ])
    );
  }

  helpContextOpenFilters() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.EXP_BUSCAR));
  }

  onCloseFilters() {
    console.log('Cerrando');
    if (this.aceptar) {
      this.pageInfo.number = 0;
      this.loadDossiers();
    } else {
      // this.searchSettings.filtersSearch = this.tmpFiltros;
      // let viewPrefs = this.getDossierViewPrefs;
      // viewPrefs = this.tmpFiltros;
      this._dossierViewPrefs = this.tmpFiltros;
    }
    this.filtersVisible = false;
    this.tmpFiltros = {};
    this.loadHelp();
  }

  ngAfterContentInit(): void {
    this.loadConfigHeader();

  }

  loadHeaders(actionImport: ActionDefinitionDTO): void {
    this.headerActionsService.clearActions();
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.headerActionsService.clearWindowActions(this.windowHash1);
    // Se inicializa la ordenación de columnas
    // TODO eliminar ?? no se usa
    if (this.tipoExpediente.includes('CONTRACTS')) {
      if (this.mySortField === 'contractFolderId') { this.mySortField = 'division.project.contractFolderId' };

    }
    this.mySortOrder = 1;

    this.subscribe(
      this.loadMassiveActions().pipe(
        tap(() => {
          //////////////////
          // Acciones de botones
          if (this.tipoExpediente.includes('CONTRACTS')) {
            this.headerActionsService.setTaskDescription(
              this.elem,
              'Contracts.reg.title',
              'fas fa-download',
              true
            );
          } else {
            this.headerActionsService.setTaskDescription(
              this.elem,
              'DossiersView.title',
              'fas fa-download',
              true
            );
            if (this.isVisibleChangeSituationCloseTaxYear) {
              this.subscribe(this.headerActionsService
                .addAction(
                  'Cambio de situación',
                  'fas fa-lg fa-check',
                  'btn-primary',
                  true
                ),
                () => {
                  this.changeSituationCloseTaxYear();
                });
            }
            if (this.isVisibleCloseTaxYear) {
              this.subscribe(this.headerActionsService
                .addAction(
                  'Cierre ejercicio',
                  'fas fa-lg fa-check',
                  'btn-primary',
                  true
                ),
                () => {
                  this.closeTaskYear();
                });
            }
          }

          this.subscribe(this.headerActionsService.addAction(
            'DossiersView.enableMasive',
            'fa fa-square-o',
            'btn-secondary',
            () => {
              return this.isEnableMasiveEnabled()
            }
          ),
            () => {
              this.selectedDossiers = [];
              this.enableMasive = true;
            });

          this.subscribe(this.headerActionsService
            .addAction('General.export.csv', 'fas fa-download', 'btn-primary', true)
            , () => {
              this.exportCSV();
            });
          this.subscribe(this.headerActionsService
            .addAction(
              'General.reload',
              'fas fa-sync-alt',
              'btn-primary',
              true
            )
            , () => {
              this.pageInfo.number = 0;
              this.loadDossiers();
            });
          this.subscribe(this.headerActionsService
            .addAction(
              'DossierList.openFilters',
              'fas fa-search',
              'btn-primary',
              true
            ),
            () => {
              this.aceptar = false;
              this.tmpFiltros = lodash.cloneDeep(this._dossierViewPrefs);
              this.helpContextOpenFilters();
              this.filtersVisible = true;
            });

          this.subscribe(this.headerActionsService
            .addAction('General.clean', 'fas fa-undo', 'btn-secondary', true),
            () => {
              this.clear();
              this.loadDossiers(); // solo se recargan en la pantalla principal
            });


          if (actionImport) {
            this.subscribe(this.headerActionsService
              .addAction(
                actionImport[0].name,
                this.actionService.getActionIconClass(actionImport[0].executableAction),
                'btn-secondary',
                true
              ),
              success => {
                this.subscribe(this.openModal(actionImport[0], ActionTypeDTO.IMPORT_CONTRACT).onClose, (result => {
                  this.loadHelp();
                }));
              });
          }

          this.headerActionsService.addDivider();
          this.subscribe(this.headerActionsService
            .addAction(
              'General.back',
              'fas fa-chevron-left',
              'btn-outline-secondary',
              true
            ),
            () => {
              this.uiService.routeBack();
            });

          this.windowHash = generateRandomIdentifier();
          this.subscribe(this.headerActionsService
            .addWindowAction(
              'General.search.text',
              'fas fa-lg fa-search',
              'btn-primary',
              true,
              this.windowHash
            ),
            () => {
              this.search();
              this.pageInfo.number = 0;
              this.loadDossiers();
            });
          this.subscribe(this.headerActionsService
            .addWindowAction(
              'General.clean',
              'fas fa-lg fa-undo',
              'btn-secondary',
              true,
              this.windowHash
            ),
            () => {
              this.clear();
            });


          // Columnas
          this.windowHash1 = generateRandomIdentifier();
          this.subscribe(this.headerActionsService
            .addWindowAction(
              'PendingTasks.sortTasks',
              'fas fa-sort-alpha-up',
              'btn-primary',
              true,
              this.windowHash1
            ),
            () => {
              this.ordenar();
              // this.loadDossiers();
            });
          //////////////////
        })
      )
    );
    this.loadDossiersSettings();
    this.dossiers = <ProcurementProjectDTO[]>this.dossiers;
  }

  loadConfigHeader(): void {

    let importContractEnabled: boolean = this.importContractEnabled();
    if (this.tipoExpediente.includes('CONTRACTS')
      && this.appConfig.getValue('import.contract')
      && importContractEnabled) {
      this.subscribe(this.plycaService.getAction(ActionTypeDTO.IMPORT_CONTRACT),
        (datos: any) => {
          this.loadHeaders(datos != null && datos.content != null ? datos.content : null);
        });
    } else {
      this.loadHeaders(null);
    }
  }

  importContractEnabled(): boolean {
    let importContractEnabled: boolean = this.appConfig.getValue('newcontract.enabled');
    let _profiles = this.appConfig.getValue('newcontract.defaultProfiles');
    if (_profiles) {
      importContractEnabled = importContractEnabled && this.userService.hasRoles(_profiles);
    }
    return importContractEnabled;
  }

  openModal(action: ActionDefinitionDTO, helpTag?: string) {
    let config: DynamicDialogConfig = {
      header: action.name,
      width: '70%',
      styleClass: 'actionStyle'
    };
    config['action'] = action.executableAction;
    config['paramsDef'] = action.parametersDefinition;
    config['helpTag'] = helpTag;
    return this.dialogService.open(ActionsProcessComponent, config);
  }

  search() {
    this.aceptar = true;
    this.filtersVisible = false;
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    try {
      this._dossierViewPrefs.sentido = this.primeColOrden;
      if (this.visibleColumns) {
        this._dossierViewPrefs.activeColumns = this.visibleColumns;
      }
      if (this.orderColumns) {
        this._dossierViewPrefs.orderColumns = this.orderColumns;
      }
      // TODO ¿Se usa??
      if (this.table && this.table.sortField) {
        this._dossierViewPrefs.orderBy = this.table.sortField;
      }
      this.userPrefs.dossiersViewPrefsV2[this.tipoExpediente] = this._dossierViewPrefs;
      let thisUserPrefs = this.userPrefs;
      this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
      this.helpService.clearContextHelp();

      this.datePipe = null;

      super.ngOnDestroy();

    } catch (e) {
      console.log(e);
    }
  }

  isEmptyFilter(filter: any): boolean {
    return (
      (!(filter instanceof Array) && !filter) ||
      (filter instanceof Array && filter.length === 0)
    );
  }

  getStyleClass(column): string {
    if (this.visibleColumns) {
      return this.visibleColumns.find(col => {
        let ret = true;
        ret = col['code'] === column['code'];
        return ret;
      })
        ? 'hidden-xs-up'
        : '';
    } else {
      return '';
    }
  }

  configureLastPendingTaskOption() {
    // console.log(this.activeColumns);
    // console.log('Comprobando si consultar la última tarea...');
    this.useLastPendingTask = false;
    this.visibleColumns.forEach((col: SelectItem) => {
      // fijamos la columna del icono
      if (col['code'] == 'lastPendingTask.description') {
        this.useLastPendingTask = true;
        //        console.log('ACTIVADA');

        // si se incluye la opcion se recarga la lista porque el dato tiene que estar disponible
        this.loadDossiers();

      }
    });
  }

  reloadDossier(event: any) {
    this.pageInfo.number = event.page;
    this.pageInfo.size = event.rows;
    this.loadDossiers();
  }

  loadDossiersSettings() {
    this.pageInfo = new PaginationInfo();
    this.pageInfo.size = 25;
    this.pageInfo.number = 0;
    this.subscribe(this.plycaService.getDossiersSearchSetting(this.tipoExpediente).pipe(finalize(() => {
      // TODO: Revisar con el servicio REST si son correctos los campos que aparecen sin descripción
      this.searchSettingsLoaded = true;
      // Se establecer las columnas de orden al abrir la pantalla
      this.updatePrimeCols();

    })),
      (s: any) => {
        console.log(s);
        this.searchSettings = s;
        // procesar las columnas
        if (this.searchSettings.columnsSearch) {
          this.allAvailableColumns = [];
          s.columnsSearch.forEach((col: SearchSettingColumnDTO) => {
            // fijamos la columna del icono
            if (col.description && col.description !== 'name') {
              // path column type
              this.allAvailableColumns.push({
                name: col.description,
                code: col.jsonFields[0],
                type: col.typeColumn,
                default: col.columnDefault
                // }
              });
              if (col.columnDefault) {
                this.defaultVisibleColumns.push({
                  name: col.description,
                  code: col.jsonFields[0],
                  type: col.typeColumn,
                  default: col.columnDefault
                });
              }
              if (col.orderedByDefault) {

                this.defaultOrderColumns.push({
                  name: col.description,
                  code: col.jsonFields[0],
                  type: col.typeColumn,
                  default: col.columnDefault
                });

              }
            }
          });
        }
        this.loadActiveColumns();
        this.loadOrderColumns();
        this.configureLastPendingTaskOption();

        // procesar los filtros
        if (s.filtersSearch) {
          s.filtersSearch.forEach(function (el) {
            let info: any = el.listInformationFilter[0];
            info.jsonField = info.jsonField.replace('.', '#');
          }, this);
        }
        this.loadDossiers();
      });


  }
  updatePrimeCols() {
    this.primeCols = [];
    let colOrder = -1;
    if (this.orderColumns.length === 1) {
      colOrder = this.primeColOrden;
    }
    this.orderColumns.forEach((ordenElement) => {
      let field = ordenElement.code;
      if (ordenElement.code === 'division.project.contractFolderId') {
        field = 'contractFolderId'
      }
      this.primeCols.push({ field: field, order: colOrder });
    })
  }
  loadDossiers(): void {
    this.filtersVisible = false;
    this.loaded = false;
    let params = this.filters2string();

    let peticion: Observable<any>;

    // PAGINACION query gestor
    params += '&size=' + this.pageInfo.size + '&page=' + this.pageInfo.number + this.getOrderColumnsParams();


    if (this.urlBase) {
      // EXPEDIENTES CONFIGURADOS EN CONFIG.JSON
      let url = 'userAPI/v1/' + this.urlBase + '/' + '?' + params;
      peticion = this.plycaService.query<ProjectEntityDTO>(url);

    } else if (this.tipoExpediente.includes('CONTRACTS')) {
      // CONTRATOS
      let url = this.configuration.CONTRACTS_SERVICE_URL + '?' + params;


      peticion = this.plycaService.query<ContractDTO>(url);
    } else {
      // EXPEDIENTES DE CONTRATACION
      // peticion = this.plycaService.getDossiersWithParams('EXP', params, null, this.useLastPendingTask);
      let url = this.configuration.PROCUREMENTPROJ_SERVICE_URL + '?' + params;
      peticion = this.plycaService.query<ProcurementProjectDTO>(url);
    }

    this.subscribe(peticion.pipe(finalize(() => (this.loaded = true))),
      (param: PaginationDTO<any>) => {
        if (param && param.content) {
          this.dossiers = param.content;
          this.pageInfo = param.page;
          // limpiar el listado de seleccionados para asegurar que esta sincronizado con los expedientes visibles
          if (this.selectedDossiers) {
            this.selectedDossiers = this.selectedDossiers.filter(dossier => this.dossiers
              .some(dossier2 => dossier2.identifier === dossier.identifier));
          }
        } else {
          this.dossiers = [];
          this.selectedDossiers = [];
        }
        this.dossiersLoaded = true;
        this.loaded = true;
        console.log('carga finalizada');
      });
  }

  exportCSV() {
    this.waitService.startWaiting();
    let params = this.filters2string();

    // Paginación csv, sin paginación
    let labelRefExpediente = this.translateService.instant('DossiersView.id.dossier');
    let labelRefContrato = this.translateService.instant('DossiersView.id.CONTRACTS');

    let export_columns = '&page=0&size'
      // Columnas exportación
      //+ '&export_columns=' + labelRefExpediente + ':'
      + '&export_columns=' + ((this.tipoExpediente?.includes('CONTRACTS')) ? labelRefContrato : labelRefExpediente) + ':'
      + ((this.tipoExpediente.includes('CONTRACTS')) ? 'division.project.contractFolderId,' : 'contractFolderId,');
    this.visibleColumns.forEach(col => {
      if (col['code'] !== 'contractFolderId') {
        export_columns += col['name'] + ':' + col['code'] + ',';
      }
    });
    params += export_columns.substring(0, export_columns.length - 1);

    let peticion: Observable<any>;

    let urlBase = this.appConfig.getValue('URL_' + this.tipoExpediente);

    if (urlBase) {
      let url = this.configuration.URL_BASE + this.configuration.UserApiUrl + this.configuration.ApiVersion;
      url += urlBase + '/' + '?' + params;
      let fileName = this.translateService.instant(urlBase + 'FileName');

      peticion = this.plycaService.getCSVFromService(url, fileName);

    } else if (this.tipoExpediente.includes('CONTRACTS')) {
      // CONTRATOS
      let url = this.configuration.URL_BASE + this.configuration.CONTRACTS_SERVICE_URL + '?' + params;
      peticion = this.plycaService.getCSVFromService(url, 'contratos');
    } else {
      let url = this.configuration.URL_BASE + this.configuration.PROCUREMENTPROJ_SERVICE_URL + '?' + params;
      peticion = this.plycaService.getCSVFromService(url, 'expedientes');
      // peticion = this.plycaService.getDossiersWithParams('EXP', params, null, this.useLastPendingTask, true);
    }

    this.subscribe(peticion.pipe(finalize(() => this.waitService.cancelWaiting())),
      (ret: any) => {
        console.log('CSV GENERADO', ret);
        this.uiService.showSuccess(this.translateService.instant('Actions.exec.ok'),
          this.translateService.instant('General.info'),
          'success'
        );
      },
      (error) => {
        this.plycaErrorHandler.showServerError(error);
        // this.uiService.showMessage(this.translateService.instant('Actions.exec.error'), 'Error', 'errorStyle');
      });
  }

  dossiersVisibles(): boolean {
    return this.dossiers && this.dossiers.length > 0;
  }

  private filters2string(): string {
    let params = '';



    // FILTROS
    params += Object.keys(this._dossierViewPrefs.filters)
      .filter(k => {
        return (
          this._dossierViewPrefs.filters[k] &&
          !this.isEmptyFilter(this._dossierViewPrefs.filters[k])
        );
      })
      .map(k => {
        if (this._dossierViewPrefs.filters[k]) {
          let val = this._dossierViewPrefs.filters[k];
          let valTemp = '';
          // 10.8 Workarround solucionar el problema del id compuesto de los MasterData
          if (typeof val === 'string') {
            if (val.indexOf('<>') != -1) {
              valTemp = val.substring(0, val.indexOf('<>'));
            } else {
              valTemp = val;
            }
          } else if (typeof val == 'boolean') {
            valTemp = '' + val;
          } else if (val instanceof Array) {
            val.forEach(v => {
              valTemp +=
                v.identifier.substring(0, v.identifier.indexOf('<>')) + ',';
            });
            valTemp = valTemp.substring(0, valTemp.length - 1);
          } else if (typeof val == 'number') {
            valTemp = '' + val;
          } else {
            if (val.identifier && val.identifier.indexOf('<>') != -1) {
              valTemp = val.identifier.substring(0, val.identifier.length - 1);
            } else if (val.identifier) {
              valTemp = val.identifier;
            } else if (val instanceof Date) {
              valTemp = '' + val.getTime();
            } else {
              valTemp = val;
            }
          }
          let key = k.replace('#', '.');
          return `${encodeURIComponent(key)}=${encodeURIComponent(valTemp)}`;
        }
      })
      .join('&');

    // Configuración de la query
    params += '&advancedQuery=true';
    if (this.tipoExpediente.includes('CONTRACTS') || this.tipoExpediente.includes('INFRASTRUCTUREPLAN')
      || this.tipoExpediente.includes('SPENDINGPROJECTS')) {

      if (this.enabledContractsReco && this.tipoExpediente === 'CONTRACTS') {
        params += '&projectDocumentClass=1';
      }

      // NamedQuery-> Se utiliza para contracts y contracts_reco
      params += '&context.name=' + this.tipoExpediente;

    }

    return params
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  public getFilterDesc(key: string) {
    try {
      let searchFilterDesc: any = this.searchSettings.filtersSearch.find(
        x => x.listInformationFilter[0].jsonField == key
      );
      return searchFilterDesc ? searchFilterDesc.description : '';
    } catch (e) {
      return 'desc';
    }
  }

  public getFilterKeyValue(key: string, value: any) {
    let definition = this.searchSettings.filtersSearch.find(
      x => x.listInformationFilter[0].jsonField == key
    );
    if (definition && definition.listInformationFilter[0].possibleValues) {
      let selectedValue = definition.listInformationFilter[0].possibleValues.find(
        x => x.identifier === value
      );
      return selectedValue ? selectedValue.description : '-';
    }
    return this.getFilterValue2(value);
  }

  public getFilterValue2(value: any) {
    try {
      if (value instanceof String) {
        return value;
      } else if (value instanceof Array) {
        let desc = '';
        value.forEach(val => {
          desc += val.description + ', ';
        });

        // eliminar el ultimo separador
        if (desc) {
          desc = desc.substring(0, desc.length - 2);
        }
        return desc;
      } else {
        if (value.label) {
          return value.label;
        }
        if (value.description) {
          return value.description;
        } else if (value.name) {
          return value.name;
        } else if (value.identifier) {
          return value.identifier;
        } else if (value instanceof Date) {
          return this.datePipe.transform(value, 'dd-MM-yyyy');
        } else {
          return value;
        }
      }
    } catch (e) {
      return 'val';
    }
  }

  public clear() {
    this._dossierViewPrefs.filters = {};
    this._dossierViewPrefs.activeColumns = [];
    // this.filteredDossiers = this.dossiers;
    this.aceptar = true;
    // this.loadDossiers();
    this.pageInfo.number = 0;
  }

  public clearFilter(filter: any) {
    delete this._dossierViewPrefs.filters[filter.key];
    // Forzamos la detección del cambio en el ojeto (creando un clon y asignandolo)
    let filters = Object.assign({}, this._dossierViewPrefs.filters);
    this._dossierViewPrefs.filters = filters;
    this.pageInfo.number = 0;
    this.pageInfo.size = 25;
    this.loadDossiers();
  }

  getFilter(jsonField: string) {
    let x = this.searchSettings.filtersSearch.find(filter => {
      return filter.listInformationFilter[0].jsonField === jsonField;
    });
    // console.log('RESULTADO BUSQUEDA FILTRO', jsonField, x);
    return x;
  }

  public loadActiveColumns() {
    if (
      this._dossierViewPrefs.activeColumns &&
      this._dossierViewPrefs.activeColumns.length != 0
    ) {
      // this.activeColumns = this._dossierViewPrefs.activeColumns;
      this.visibleColumns = this.allAvailableColumns.filter(col => (this._dossierViewPrefs.activeColumns.find(
        col2 => (col2.code === col.code)) !== undefined));
      this.invisibleColumns = this.allAvailableColumns.filter(col => (this._dossierViewPrefs.activeColumns.find(
        col2 => (col2.code === col.code)) === undefined));
    } else {
      // this.activeColumns = this.defaultColumns;
      this.visibleColumns = this.allAvailableColumns.filter(col => (this.defaultVisibleColumns.find(
        col2 => (col2.code === col.code)) !== undefined));
      this.invisibleColumns = this.allAvailableColumns.filter(col => (this.defaultVisibleColumns.find(
        col2 => (col2.code === col.code)) === undefined));
    }
  }


  public loadOrderColumns() {
    if (
      this._dossierViewPrefs.orderColumns &&
      this._dossierViewPrefs.orderColumns.length != 0
    ) {
      // this.activeColumns = this._dossierViewPrefs.activeColumns;
      this.orderColumns = this.allAvailableColumns.filter(col => (this._dossierViewPrefs.orderColumns.find(col2 => (col2.code === col.code)) !== undefined));
      this.noOrderColumns = this.allAvailableColumns.filter(col => (this._dossierViewPrefs.orderColumns.find(col2 => (col2.code === col.code)) === undefined));
    } else {
      // this.activeColumns = this.defaultColumns;
      this.orderColumns = this.defaultOrderColumns.filter(col => (this.allAvailableColumns.find(col2 => (col2.code === col.code)) !== undefined));
      this.noOrderColumns = this.allAvailableColumns.filter(col => (this.defaultOrderColumns.find(col2 => (col2.code === col.code)) === undefined));
    }
  }

  public updateActiveColumns() {
    this.configureLastPendingTaskOption();
  }

  setFilterSelectOption(filter: any, index: any, option: any): void {
    if (filter && index && option && option.value) { filter[index] = option.value; }
  }

  toMultiValueOptions(options: Array<any>) {
    let ret = [];
    if (options) {
      options.forEach((opc: MasterDataDTO) => {
        ret.push({
          label: opc.description,
          value: opc
        });
      });
    }
    return ret;
  }

  public createFieldConfig(filter: any, i: number): FieldConfig {
    let config = new FieldConfig();
    let type = filter.listInformationFilter[0].type;
    let jsonField: string = filter.listInformationFilter[0].jsonField;
    let subtype = filter.listInformationFilter[0].subtype;
    let defaultValue = filter.listInformationFilter[0].defaultValue;
    config.jsonField = jsonField;
    // config.id = jsonField;
    config.type = type;
    config.showInfo = (this.userService.hasRoles('0,50')
      && this.userPrefs && this.userPrefs.mainViewPrefs && this.userPrefs.mainViewPrefs.showHelpTags);
    ;

    if (type === 'STRING') {
      if (jsonField === 'organizationalUnitId') {
        config.type = 'UOSEARCH';
      } else if (jsonField === 'usuId') {
        config.type = 'SEARCH';
        config.idBuscador = 'BuscadorPromotores';
        config.autoSearch = true;
      } else {
        config.type = 'STRING';
      }
    } else if (type === 'DECIMAL') {
      config.type = 'DECIMAL';
    } else if (type === 'INTEGER') {
      config.type = 'INTEGER';
    } else if (type === 'CURRENCY') {
      config.type = 'CURRENCY';
    } else if (type === 'CHECK') {
      config.type = 'CHECK';
    } else if (type === 'DROPDOWN') {
      config.type = 'DROPDOWN';
      config.orderByDescription = false;
      config.data = [];
      if (filter.listInformationFilter[0].possibleValues) {
        filter.listInformationFilter[0].possibleValues.forEach((val) =>
          config.data.push({ label: val.description, value: val.identifier })
        );
      }
    } else if (type === 'LIST') {
      config.type = 'DROPDOWN';

      // TODO: MODIFICAR ESTO -> SOLAMENTE SE UTILIZA MASTERDATA. SE EXTRAE LA TABLA DE LA URL
      let idBuscador: string = (filter.listInformationFilter[0].search) ?
        filter.listInformationFilter[0].search.identifier : filter.listInformationFilter[0].links[0].href;

      idBuscador = idBuscador.substring(idBuscador.lastIndexOf('/') + 1);
      config.idBuscador = idBuscador;
      if (filter.listInformationFilter[0].search) {
        config.autoSearch = true;
        config.parameters = filter.listInformationFilter[0].search.parameters;
      }
    } else if (type === 'MULTIVALUELIST') {
      config.type = 'MULTISELECT';


      // TODO: MODIFICAR ESTO -> SOLAMENTE SE UTILIZA MASTERDATA. SE EXTRAE LA TABLA DE LA URL
      let idBuscador: string = (filter.listInformationFilter[0].search) ?
        filter.listInformationFilter[0].search.identifier : filter.listInformationFilter[0].links[0].href;

      idBuscador = idBuscador.substring(idBuscador.lastIndexOf('/') + 1);
      config.idBuscador = idBuscador;
      if (filter.listInformationFilter[0].search) {
        config.autoSearch = true;
        config.parameters = filter.listInformationFilter[0].search.parameters;
      }
    } else if (type === 'YEAR') {
      config.type = 'MASK';
      config.pattern = '9999';
    } else if (type === 'SEARCH') {
      // En los type=SEARCH nos indican en SUBTYPE el nombre del buscador
      if (subtype === 'UOSEARCH') {
        config.type = subtype;
      } else {
        config.idBuscador = subtype;
        if (!config.idBuscador && filter.listInformationFilter[0].search) {
          config.idBuscador = filter.listInformationFilter[0].search.identifier;
          config.parameters = filter.listInformationFilter[0].search.parameters;
        }
      }
    }
    if (defaultValue && type !== 'DROPDOWN') {
      config.value = defaultValue;
    }

    if (config?.type == 'UOSEARCH') {
      config.type = 'SEARCH';
      config.idBuscador = 'com.nexusit.framework.buscador.interfaz.BuscadorOrganismos';


    }
    config.fieldStyle = 'col-sm-12 col-md-6';
    config.tooltipText = filter.description;
    config.description = filter.description;
    if (i === 0) {
      config.autofocus = true;
    }
    return config;
  }


  showColumnsSelector() {
    this.selectColumnsVisible = true;
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.EXP_CONFIG_VIEW));
  }

  onCloseColumnSelector() {
    this.updateActiveColumns(); // Hace un loaddossiers
    this.updatePrimeCols();
    this.selectColumnsVisible = false;

    this.loadHelp();
  }

  clearColumns() {

    this.visibleColumns = this.defaultVisibleColumns;
    this.orderColumns = this.defaultOrderColumns;

  }
  mostrarPanelFiltros() {

    return JSON.stringify(this._dossierViewPrefs.filters) !== '{}'
  }

  getOrderColumnsParams(): string {
    // &sort=phase.description';
    console.log(this.orderColumns);
    let orderParams = '';
    let desc = '';
    if (this.orderColumns.length === 1 && this.primeColOrden === 1) {
      desc = ',desc';
    }
    this.orderColumns.forEach((ordenElement) => {
      orderParams += '&sort=' + ordenElement.code + desc;

    })
    console.log(orderParams);

    return orderParams;
  }
  ordenar() {
    this.aceptar = true;
    this.filtersVisible = false;
    this.selectColumnsVisible = false;
    this.pageInfo.number = 0;
    this.loadDossiers();
  }


  customSort(event: any) {
    // event.data = Data to sort
    // event.mode = 'single' or 'multiple' sort mode
    // event.field = Sort field in single sort
    // event.order = Sort order in single sort
    // event.multiSortMeta = SortMeta array in multiple sort


    // Solo se entra aquí al pinchar en una columna para ordenarla
    // Se invierte el orden de ordenación

    // Multi ordenacion
    if (event.multisortmeta) {
      this.orderColumns = [];
      event.multisortmeta.forEach(element => {
        let field = element.field;
        if (this.tipoExpediente.includes('CONTRACTS')) {
          if (field === 'contractFolderId') { field = 'division.project.contractFolderId' };

        }
        let clickColumn = this.allAvailableColumns.find(c => c.code === field);
        this.orderColumns.push({
          code: field,
          name: clickColumn.name
        }
        );
        // Para que sepa la ordenación al pinchar en el botón de la página
        this.primeColOrden = this.primeColOrden * -1;
        // Se lleva a la página primera tras la consulta a servidor
        this.pageInfo.number = 0;
        this.loadDossiers();
        this.updatePrimeCols();

        // this.primeColOrden = this.primeColOrden * -1;
      });

    }
  }

  public getDossierMenuItem(dto: any): MenuItem[] {
    let isOtherDossier = this.appConfig.getValue('URL_' + this.tipoExpediente) != null;
    this.cliente = this.appConfig.getValue('cliente');
    if (isOtherDossier) {
      return this.loadOtherDossierLinks(dto);
    } else if (dto.phase) {
      return this.loadDossierLinks(dto);
    } else {
      return this.loadContractLinks(dto);
    }
  }

  public loadContractLinks(dossier: any): Array<MenuItem> {
    let identifier = dossier.division.project.identifier;
    let items: MenuItem[] = [];

    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    if ('AYMAD' === this.cliente) {
      this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    } else {
      this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTS');
    }
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.COMMUNICATIONS.short', 'fa fa-envelope-open-text', 'COMMUNICATIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');
    if (this.calendarEnabled) {
      this.addLink(items, identifier, 'DossierInfo.sections.CALENDAR.short', 'fa fa-calendar', 'CALENDAR');
    }

    if (this.VER_ReassignmentOption) {
      let mn = <MenuItem>{};
      mn.label = this.translateService.instant('TaskAssignment.title');
      mn.title = this.translateService.instant('TaskAssignment.title');
      mn.icon = 'fas fa-briefcase';
      mn.command = (event?: any) => {
        this.openAssignment(dossier);
      };
      items.push(mn);
    }
    return items;
  }

  public loadOtherDossierLinks(dossier: any): Array<MenuItem> {
    let identifier = dossier.identifier;
    let items: MenuItem[] = [];

    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.COMMUNICATIONS.short', 'fa fa-envelope-open-text', 'COMMUNICATIONS');
    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');
    this.loadDossierGenericLinks(dossier, items);
    if (this.calendarEnabled) {
      this.addLink(items, identifier, 'DossierInfo.sections.CALENDAR.short', 'fa fa-calendar', 'CALENDAR');
    }
    return items;
  }

  public loadDossierGenericLinks(dossier: any, items: MenuItem[]) {
    let mn = <MenuItem>{};
    // TODO esto es para que te deje acceder a la edición desde la rueda de opciones del gestor. Hacer también para gastos
    let profile = this.appConfig.getValue('infrastructurePlan.edition.profiles');
    let text = 'DossierLinks.viewGenericDossier';
    let icon = 'fas fa-eye';
    if (profile) {
      if (this.userService.hasRoles(profile)) {
        text = 'DossierLinks.editGenericDossier';
        icon = 'fas fa-pen';
      }

      this.subscribe(
        this.translateService
          .get(text)
        , ((res: string) => {
          mn.label = res;
        }
        )
      );
      mn.icon = icon;
    }

    let url = '';
    if (dossier != null && dossier.documentClass != null && dossier.documentClass.identifier != null) {
      if (dossier.documentClass.identifier == '05000') {
        url = this.appConfig.getValue('url.edit.infrastructurePlan');

        mn.routerLink = [url, dossier.identifier];

        items.push(mn);
      }
    }

    let profileSpendingProject = this.appConfig.getValue('spendingProject.view.profiles');
    text = 'DossierLinks.viewGenericDossier';
    icon = 'fas fa-eye';
    if (profileSpendingProject) {
      this.subscribe(
        this.translateService
          .get(text)
        , ((res: string) => {
          mn.label = res;
        }
        )
      );
      mn.icon = icon;
    }

    url = '';
    if (dossier != null && dossier.documentClass != null && dossier.documentClass.identifier != null) {
      if (dossier.documentClass.identifier == '05002') {
        url = this.appConfig.getValue('url.edit.spendingProject');
        mn.queryParams = { readOnly: true };
        mn.routerLink = [url, dossier.identifier];

        items.push(mn);
      }
    }

  }

  public loadDossierLinks(dossier: any): Array<MenuItem> {
    let identifier = dossier.identifier;
    let documentClass = dossier.documentClass ? dossier.documentClass.identifier : dossier.division.documentClass.identifier;
    let phaseId = dossier.phase.identifier;
    let hideCopy = this.hideDossierCopy;

    let mn: MenuItem = {};
    let items: MenuItem[] = [];

    items = this.getDossierLinks(identifier, false, documentClass);

    // PANTALLA DE SITUACION DE ACUERDOS MARCO Y PANTALLA DE RELACION DE PRECIOS UNITARIOS DE AYMAD
    if (this.cliente && this.cliente === 'AYMAD') {
      let complementarySystem = dossier?.classification?.complementarySystem?.identifier;
      let withoutUnitPrice = dossier?.budget?.withoutUnitPrice;
      if (complementarySystem !== undefined) {
        if (complementarySystem === 'AM<>SISTCOMPLEMENTARIO' || complementarySystem === 'CBAM<>SISTCOMPLEMENTARIO') {
          this.addLink(items, identifier, 'Situación AM y CBAM', 'fas fa-file-contract', 'FRAMEWORKAGREEMENTSITUATIONAYMAD');
          if (!withoutUnitPrice) {
            this.addLink(items, identifier, 'Precios Unitarios', 'fas fa-file-excel', 'UNITPRICERELACIONDOCUMENTAYMAD');
          }
        } else if (complementarySystem === 'CSDA<>SISTCOMPLEMENTARIO') {
          this.addLink(items, identifier, 'Situación SDA y CSDA', 'fas fa-file-contract', 'DYNAMICPURCHASINGSYSTEMAYMAD');
        }
      }
    }

    mn = <MenuItem>{};
    this.subscribe(
      this.translateService
        .get('DossierLinks.showFE')
      , ((res: string) => {
        mn.label = res;
      }));

    //if (this.profileService.isUserCanViewFE(undefined, phaseId)) {
    // Boton de Visualizar se ve siempre
    mn.icon = 'fas fa-eye';
    mn.queryParams = { readonly: true };
    mn.routerLink = ['/procurementProject', identifier];
    // Dependiendo del cliente, se llamará una ruta u otra
    if (this.cliente && this.cliente === 'AYMAD') {
      mn.routerLink = ['/procurementProjectAYMAD', identifier];
    }
    if (this.cliente && this.cliente === 'DIPBAD') { // TODO creo que aquí me sobra el de gasto porque no tiene botón de editar
      if (dossier != null && dossier.documentClass != null && dossier.documentClass.identifier != null) {
        if (dossier.documentClass.identifier == '05000') {
          mn.routerLink = ['/infrastructurePlans', identifier];
        } else if (dossier.documentClass.identifier == '05002') {
          mn.routerLink = ['/spendingProjects', identifier];
        }
      }
    }

    items.push(mn);
    mn.id = 'VERFICHA';
    //}




    /*this.subscribe(
      this.profileService.isUserCanPrepareProject(identifier, phaseId)
        .pipe(
          tap((result) => {
            if (result === true) {
              mn = <MenuItem>{};
              this.subscribe(
                this.translateService
                  .get('DossierLinks.prepare')
                , ((res: string) => {
                  mn.label = res;
                }));

              // mn.label = 'Calendario del expediente';
              mn.icon = 'fas fa-pen';
              // mn.routerLink = ['/dossierCreation', identifier];

              // Dependiendo del cliente, se llamará una ruta u otra
              mn.routerLink = ['/procurementProject', identifier];

              if (this.cliente && this.cliente === 'AYMAD') {
                mn.routerLink = ['/procurementProjectAYMAD', identifier];
              }
              items.push(mn);
            }
          })
        )
    );*/


    // boton copiar
    if (this.VER_COPIAR) {
      if (hideCopy !== true) {
        mn = <MenuItem>{};
        mn.label = this.translateService.instant('General.copy');
        mn.icon = 'fas fa-copy';
        mn.command = (event?: any) => {
          this.waitService.startWaiting();
          this.subscribe(this.plycaService.execAction(
            this.configuration.PROCUREMENTPROJ_SERVICE_URL,
            identifier,
            'CLONE_PROJECT_TENDERDEF'
          ),
            (result: ActionDefinitionResult) => {
              this.waitService.cancelWaiting();
              let clonedProject = result.objectResult as ProcurementProjectDTO;
              this.subscribe(this.uiService.showMessage(
                this.translateService.instant('DossierLinks.clonedProject',
                  {
                    newProjectId: ProcurementProjectDTO.normalizaDossierId(clonedProject.identifier)
                  }),
                this.translateService.instant('General.info')
              ).onClose, () => this.loadDossiers());
            },
            (error: any) => {

              this.plycaErrorHandler.showServerError(error);
              this.waitService.cancelWaiting();
              console.error(error);
            }
          );
        };
        items.push(mn);
      }
    }

    // Ficha de gestión de acceso de usuarios a expedientes
    if (this.VER_ProjectEntityUserAuthorizationForm) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService
          .get('ProjectEntityUserAuthorization.Links.ProjectEntityUserAuthorization.ShortTitle')
        , ((res: string) => {
          mn.label = res;
        }));
      this.subscribe(
        this.translateService
          .get('ProjectEntityUserAuthorization.Links.ProjectEntityUserAuthorization.Title')
        , ((res: string) => {
          mn.title = res;
        }));
      mn.icon = 'fas fa-user-shield';
      mn.routerLink = ['/projectEntityUserAuthorization', identifier, ''];
      items.push(mn);
    }

    // Ficha de gestión de acceso de usuarios a expedientes para autorizaciones de tipo DACI
    if (this.VER_ProjectEntityUserAuthorizationFormDACI) {
      mn = <MenuItem>{};
      this.subscribe(
        this.translateService
          .get('ProjectEntityUserAuthorization.Links.ProjectEntityUserAuthorizationDACI.ShortTitle')
        , ((res: string) => {
          mn.label = res;
        }));
      this.subscribe(
        this.translateService
          .get('ProjectEntityUserAuthorization.Links.ProjectEntityUserAuthorizationDACI.Title')
        , ((res: string) => {
          mn.title = res;
        }));
      mn.icon = 'fas fa-user-shield';
      mn.routerLink = ['/projectEntityUserAuthorization', identifier, 'D'];
      items.push(mn);
    }

    if (this.VER_ReassignmentOption) {
      mn = <MenuItem>{};
      mn.label = this.translateService.instant('TaskAssignment.title');
      mn.title = this.translateService.instant('TaskAssignment.title');
      mn.icon = 'fas fa-briefcase';
      mn.command = (event?: any) => {
        this.openAssignment(dossier);
      };
      items.push(mn);
    }
    return items;
  }

  addLink(items: MenuItem[], identifier: string, description: string, icon: string, componentName: string) {
    let mn: MenuItem = {};
    this.subscribe(
      this.translateService.get(description), ((res: string) => {
        mn.label = res;
      }));
    mn.icon = icon;
    mn.routerLink = ['/dossierInfo', identifier];
    mn.queryParams = { component: componentName };
    items.push(mn);

  }

  public getDossierLinks(identifier: string, separator: boolean, documentClass: string): Array<MenuItem> {
    let items: MenuItem[] = [];

    this.addLink(items, identifier, 'DossierInfo.sections.GENERAL_INFO.short', 'fa fa-info-circle', 'GENERAL_INFO');
    this.addLink(items, identifier, 'DossierInfo.sections.DOSSIER_ACTIONS.short', 'fa fa-tasks', 'DOSSIER_ACTIONS');
    if ('AYMAD' === this.cliente) {
      this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTSAYMAD');
    } else {
      this.addLink(items, identifier, 'DossierInfo.sections.CONTRACTS.short', 'fa fa-file-contract', 'CONTRACTS');
    }
    this.addLink(items, identifier, 'DossierInfo.sections.DOCUMENTS.short', 'fa fa-file-alt', 'DOCUMENTS');
    this.addLink(items, identifier, 'DossierInfo.sections.ACCOUNTING.short', 'fa fa-euro-sign', 'ACCOUNTING');
    this.addLink(items, identifier, 'DossierInfo.sections.COMMUNICATIONS.short', 'fa fa-envelope-open-text', 'COMMUNICATIONS');

    if (this.VER_PREGUNTAS) {
      this.addLink(items, identifier, 'DossierInfo.sections.QUESTIONS.short', 'fa fa-question-circle', 'QUESTIONS');
    }
    if (this.profileService.isOptionEnabled('PLANNING', documentClass)) {
      this.addLink(items, identifier, 'DossierInfo.sections.PLANNING.short', 'fa fa-clock', 'PLANNING');
    }

    this.addLink(items, identifier, 'DossierInfo.sections.PROCEDURES.short', 'fa fa-list-ul', 'PROCEDURES');
    this.addLink(items, identifier, 'DossierInfo.sections.AUDIT.short', 'fa fa-lg fa-list-ul', 'AUDIT');
    if (this.calendarEnabled) {
      this.addLink(items, identifier, 'DossierInfo.sections.CALENDAR.short', 'fa fa-calendar', 'CALENDAR');
    }

    return items;
  }

  loadHelp() {
    if (
      this.tipoExpediente === 'EXP'
    ) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.HELP_DOSSIER));
    } else if (this.tipoExpediente.includes('CONTRACTS')) {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.REG_CONTRACT));
    } else {
      let helpContext = this.appConfig.getValue('HELP_' + this.tipoExpediente);
      if (helpContext) {
        this.subscribe(this.helpService.showContextHelpObservable(helpContext));

      }
    }
  }

  getDtoTypeForActions() {
    let dtoType = this.appConfig.getValue('DTO_' + this.tipoExpediente);
    if (dtoType) {
      return dtoType;
    } else {
      return 'PROJECTENTITY';
    }
  }

  // ************************************ LEGANES **************************************************************
  // ***************************** * /
  public closeTaskYear(): void {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let completedResult = true;
    let autoSearch = false;
    let searchConfig = new SearchConfig();
    searchConfig.multiSelection = true;
    searchConfig.actionCfg = {
      rowFn: this.rowFnCloseTaskYear.bind(this),
      preExcuteFn: this.preExcuteFnCloseTaskYear.bind(this)
    };
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONCLOSETAXYEARSEARCH',
      autoSearch,
      parametersURL,
      completedResult,
      searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;

    const ref = this.dialogService.open(searchGenericComponent, config);

  }


  public rowFnCloseTaskYear(row: SearchResultDTO) {

    // let objectType = 'USER';
    // let action = 'CLOSE_TAXYEAR';
    let paramNames = ['CLOSE_TAXYEAR_CAPTURENUMBER', 'CLOSE_TAXYEAR_CAPTUREDATE', 'CLOSE_TAXYEAR_TAXYEAR']
    let objIdentifier = this.userService.getUserId();

    let parameters: string;
    if (paramNames) {
      parameters = '';
      let separator = '';
      paramNames.forEach(paramColumn => {
        let attrValue = row.content[paramColumn];
        if (attrValue && attrValue.value) {
          parameters += separator + paramColumn + '=' + attrValue.value;
          separator = '&';
        }
      });
    }
    parameters += '&CLOSE_TAXYEAR_IDPROCESO=' + this.processRegisterInfo.registerNumber;
    return this.plycaService.runAction(this.actionIdCloseTaxYear, objIdentifier, parameters);
  }


  public preExcuteFnCloseTaskYear(row: SearchResultDTO, filters: any) {

    // let objectType = 'USER';
    let objIdentifier = this.userService.getUserId();

    let sDate;
    let sEjercicio;
    if (filters && filters.INTEGRATIONCLOSETAXYEARSEARCH) {
      sDate = filters.INTEGRATIONCLOSETAXYEARSEARCH.FCAPTURA;
      sEjercicio = filters.INTEGRATIONCLOSETAXYEARSEARCH.ANOINICIO;
    }

    let processParameters = '';
    let separator = ';';
    let sDescripcion = 'Cierre.Ejercicio';
    if (sDate) {
      processParameters = 'FCAPTURA=' + sDate;
    }
    if (sEjercicio) {
      if (processParameters && processParameters != '') {
        processParameters += 'separator';
      }
      processParameters += 'ANOINICIO=' + sEjercicio;
    }

    let parameters = 'PROCESS_DESCRIPCION=' + sDescripcion + '&' + 'PROCESS_PARAMETERS=' + processParameters;

    return this.plycaService.runAction(this.actionIdProcessRecordId, objIdentifier, parameters).pipe(
      map((result: ActionResultDTO) => {
        let actionResult = new SearchActionResultDTO();
        actionResult.success = (result.identifier === 'OK');
        actionResult.description = result.description;
        actionResult.objectResult = result;
        if (result) {
          if ('OK' === result.identifier) {
            if (result.objectResult) {
              this.processRegisterInfo = result.objectResult;
            }
          }
        }
        return actionResult;
      })
    );
  }


  public changeSituationCloseTaxYear(): void {
    let parametersURL: ActionParameterDefinitionDTO[] = [];

    let completedResult = true;
    let autoSearch = false;
    let searchConfig = new SearchConfig();
    searchConfig.multiSelection = true;
    searchConfig.actionCfg = {
      rowFn: this.rowFnChangeSituationCloseTaxYear.bind(this),
      preExcuteFn: this.preExcuteFnChangeSituationCloseTaxYear.bind(this),
      postExecuteFn: this.postExcuteFnChangeSituationCloseTaxYear.bind(this)
    };
    let contextSearch = new SearchSettingDTOModal(
      'INTEGRATIONCHANGESTATUSSITUATIONSEARCH',
      autoSearch,
      parametersURL,
      completedResult,
      searchConfig
    );
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { overflow: 'scroll', 'max-height': '80%' }
    };
    config['context'] = contextSearch;

    const ref = this.dialogService.open(searchGenericComponent, config);
  }
  public postExcuteFnChangeSituationCloseTaxYear(row: SearchResultDTO) {
    console.log('************ postExcuteFnChangeSituationCloseTaxYear*********************************');
    return of({});
  }

  public preExcuteFnChangeSituationCloseTaxYear(row: SearchResultDTO, filters: any) {
    console.log('************ preExcuteFnChangeSituationCloseTaxYear*********************************');

    // this.waitService.startWaiting();
    // let objectType = 'USER';
    // let paramNames = ['PROCESS_DESCRIPCION', 'PROCESS_PARAMETERS'];
    // let objIdentifier = row.content['PROPUESTAID'].value;
    let objIdentifier = this.userService.getUserId();

    let sEjercicio;
    let sExpedienteId;
    if (filters && filters.INTEGRATIONCHANGESTATUSSITUATIONSEARCH) {
      //  parametersDefinition: [{identifier: "INTEGRATIONCHANGESTATUSSITUATIONSEARCH.ANIOPRESUPUESTO",…},…]
      //      0: {identifier: "INTEGRATIONCHANGESTATUSSITUATIONSEARCH.ANIOPRESUPUESTO",…}
      //      1: {identifier: "INTEGRATIONCHANGESTATUSSITUATIONSEARCH.EXPEDIENTEID",…}

      sEjercicio = filters.INTEGRATIONCHANGESTATUSSITUATIONSEARCH.ANIOPRESUPUESTO;
      sExpedienteId = filters.INTEGRATIONCHANGESTATUSSITUATIONSEARCH.EXPEDIENTEID;
    }

    let processParameters = '';
    // let separator = '&';
    let separator = ';';
    let sDescripcion = 'Cambio.Situacion';
    if (sExpedienteId) {
      processParameters = 'EXPEDIENTEID=' + sExpedienteId;
    }
    if (sEjercicio) {
      if (processParameters && processParameters != '') {
        processParameters += 'separator';
      }
      processParameters += 'EJERCICIO=' + sEjercicio;
    }

    let parameters = 'PROCESS_DESCRIPCION=' + sDescripcion + '&' + 'PROCESS_PARAMETERS=' + processParameters;

    return this.plycaService.runAction(this.actionIdProcessRecordId, objIdentifier, parameters).pipe(
      map((result: ActionResultDTO) => {
        console.log('************ preExcuteFnChangeSituationCloseTaxYear -> runAction*********************************');
        let actionResult = new SearchActionResultDTO();
        actionResult.success = (result.identifier === 'OK');
        actionResult.description = result.description;
        actionResult.objectResult = result;
        if (result) {
          if ('OK' === result.identifier) {
            if (result.objectResult) {
              this.processRegisterInfo = result.objectResult;
            }
          }
        }
        return actionResult;
      })
    );
  }

  public rowFnChangeSituationCloseTaxYear(row: SearchResultDTO): Observable<SearchActionResultDTO> {
    console.log('************ rowFnChangeSituationCloseTaxYear*********************************');
    // let objectType = 'PROCUREMENTPROJECT';
    // let action = 'LEGANES_CHANGE_STATUS_SITUATION_CLOSE_TAX_YEAR';
    let paramNames = ['EXPEDIENTEID', 'ANIOPRESUPUESTO'];
    let objIdentifier = row.content['PROPUESTAID'].value;

    let parameters: string;
    if (paramNames) {
      parameters = '';
      let separator = '';
      paramNames.forEach(paramColumn => {
        let attrValue = row.content[paramColumn];
        if (attrValue && attrValue.value) {
          parameters += separator + paramColumn + '=' + attrValue.value;
          separator = '&';
        }
      });
      parameters += '&IDPROCESO=' + this.processRegisterInfo.registerNumber;
    }

    return this.plycaService.runAction(this.actionIdChangeStatusSituation, objIdentifier, parameters).pipe(
      map((result: ActionResultDTO) => {
        console.log('************ rowFnChangeSituationCloseTaxYear -> runAction*********************************');
        let actionResult = new SearchActionResultDTO();
        actionResult.success = (result.identifier === 'OK');
        actionResult.description = result.description;
        actionResult.objectResult = result;
        return actionResult;
      })
    );
  }
  setVisibleChangeSituationCloseTaxYear() {
    this.isVisibleChangeSituationCloseTaxYear = this.appConfig.getValue('dossier-view.button.changeSituationCloseTaxYear');
    let _profiles = this.appConfig.getValue('dossier-view.button.changeSituationCloseTaxYear.defaultProfiles');
    if (_profiles) {
      this.isVisibleChangeSituationCloseTaxYear = this.isVisibleChangeSituationCloseTaxYear && this.userService.hasRoles(_profiles);
    }
  }

  setVisibleCloseTaxYear() {
    this.isVisibleCloseTaxYear = this.appConfig.getValue('dossier-view.button.closeTaxYear');
    let _profiles = this.appConfig.getValue('dossier-view.button.closeTaxYear.defaultProfiles');
    if (_profiles) {
      this.isVisibleCloseTaxYear = this.isVisibleCloseTaxYear && this.userService.hasRoles(_profiles);
    }
  }
  // ************************************ FIN LEGANES ****************************************************
  // *************************************** * /
  loadMassiveActions(): Observable<any> {
    // this.subscribe(
    return this.plycaService
      .getActionsByObjectType('PROJECTENTITY', 'async=true')
      .pipe(
        tap((actions: PaginationDTO<ActionDefinitionDTO>) => {
          if (actions && actions.content) {
            this.masiveAvailable = true;
            this.headerActionsService.addActionGroup(
              'massive.actions',
              undefined,
              'fas fa-cog',
              'btn-secondary',
              () => {
                return this.isMasiveEnabled()
              }
            );

            this.subscribe(this.headerActionsService.addActionToGroup(
              'massive.actions',
              'DossiersView.disableMasive',
              'fa fa-check-square-o',
              'btn-secondary',
              () => {
                return this.isMasiveEnabled()
              }
            ),
              () => {
                this.selectedDossiers = [];
                this.enableMasive = false;
              });

            actions.content.forEach(_action => {
              this.subscribe(this.headerActionsService.addActionToGroup(
                'massive.actions',
                _action.name,
                _action.icon,
                'btn-secondary',
                true
              ),
                () => {
                  // this.openMultiDossierActionComponent(_action);
                  this.openMultiDossierActionModal(_action, '');
                });
            });
          }
        })
      )
    // );

    // if (this.massiveActionsConfig && this.massiveActionsConfig.length > 0) {

    //   if (multiSignatureEnabled) {
    //     this.subscribe(this.headerActionsService.addActionToGroup(
    //       'massive.actions',
    //       'MultiSignature.action',
    //       'fas fa-lg fa-pen-nib',
    //       'btn-secondary',
    //       this.multiSignatureAvailable
    //     ),
    //       () => {
    //         this.openMultiSignatureComponent();
    //       });
    //   }
    //   this.massiveActionsConfig.forEach(action => {

    //     this.subscribe(
    //       // consultar accion
    //       this.plycaService.query<ActionDefinitionDTO>(this._configuration.ACTIONDEFINICION_SERVICE_URL, {
    //         actionObjType: 'TASK',
    //         id: action.config.action
    //       }).pipe(
    //         catchError((error: any) => {
    //           console.warn('Error al consultar la accion', action?.config?.action);
    //           return EMPTY;
    //         }),
    //         tap((result: PaginationDTO<ActionDefinitionDTO>) => {
    //           if (!result || !result.content || result.content.length === 0) {
    //             console.warn('Acción no disponible -> ', action?.config?.action);
    //           } else {
    //             console.log('Cargamos la acción  -> ', action?.config?.action, 'action.visible:' + eval(action.visible));
    //             this.subscribe(this.headerActionsService.addActionToGroup(
    //               'massive.actions',
    //               action.name,
    //               action.icon,
    //               action.classes,
    //               // tslint:disable-next-line:no-eval
    //               eval(action.visible)
    //             ),
    //               () => {
    //                 this.openMultiTaskComponent(action.name, action.config);
    //               });
    //           }
    //         }))
    //     )
    //   });
    // } else if (multiSignatureEnabled) {
    //   if (multiSignatureEnabled) {
    //     this.subscribe(this.headerActionsService.addAction(
    //       'MultiSignature.action',
    //       'fas fa-lg fa-pen-nib',
    //       'btn-secondary',
    //       this.multiSignatureAvailable
    //     ),
    //       () => {
    //         this.openMultiSignatureComponent();
    //       });
    //   }
    // }
  }

  isMasiveEnabled(): boolean {
    return this.masiveAvailable && this.enableMasive;
  }

  isEnableMasiveEnabled(): boolean {
    // si esta habilitado ya, opcion de habilitar la masiva invisible
    if (this.enableMasive) {
      return false;
    } else {
      // si no esta habilitado, esta visible la opcion de habilitar si hay acciones masivas
      return this.masiveAvailable;
    }
  }

  openMultiDossierActionModal(action: ActionDefinitionDTO, helpTag?: string) {
    if (this.selectedDossiers && this.selectedDossiers.length > 0) {
      let config: DynamicDialogConfig = {
        header: action.name,

        width: '70%',
        styleClass: 'actionStyle'

      };
      config['action'] = action.executableAction;
      config['paramsDef'] = action.parametersDefinition;
      config['helpTag'] = helpTag;
      // TODO: SI LLEGAN EXPEDIENTES DE DISTINTO TIPO ORDENAMOS.
      // SOLO TENDRIA QUE PASAR EN CONTRATOS.GETSIONAMOS PRIMERO LOS 0600 QUE LOS 0000
      config['multipleTargetList'] = this.selectedDossiers.sort((dossier1, dossier2) => {
        try {
          if (dossier1.division.project.documentClass.identifier > dossier2.division.project.documentClass.identifier) {
            return -1;
          }
        } catch { }
        return 1;
      }).map((dossier) => {
        if (dossier.division && dossier.division.project) {
          return dossier.division.project.identifier;
        } else {
          return dossier.identifier;
        }
      }).filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
      config['runAction'] = true;
      let ref = this.dialogService.open(ActionsProcessComponent, config);
      return this.subscribe(ref.onClose, () => {
        this.loadDossiers();
      }
      )
    }
  }

  public openAssignment(dossier: DossierDTO): void {
    let taskConfig = new TaskAssignmentComponentConfig();
    taskConfig.project = dossier;
    let config: DynamicDialogConfig = {
      header: this.translateService.instant('TaskAssignment.title'),
      width: '80%',
      data: taskConfig
    };
    this.subscribe(this.dialogService.open(TaskAssignmentComponent, config).onClose);
  }

  public updateActions(this1: any, items: MenuItem[]): Observable<MenuItem[]> {
    return this.profileService.isUserCanPrepareProject(this1.identifier, this1.phase.identifier).pipe(
      tap((result) => {
        if (result === true) {
          let mn: MenuItem = {};
          mn.icon = 'fas fa-pen';
          mn.label = this.translateService.instant('DossierLinks.prepare');
          // Dependiendo del cliente, se llamará una ruta u otra
          mn.routerLink = ['/procurementProject', this1.identifier];

          if (this.cliente && this.cliente === 'AYMAD') {
            mn.routerLink = ['/procurementProjectAYMAD', this1.identifier];
          }
          const index = items.findIndex(item => item.id === 'VERFICHA');
          // Verificar si se encontró el objeto con id igual a 'VERFICHA'
          if (index !== -1) {
            items.splice(index + 1, 0, mn);
            console.log('Array después de la inserción:', items);
          } else {
            items.push(mn);
          }
        }
      }),
      catchError((error: any) => {
        // Manejar el error como desees
        console.error('Error in updateActions:', error);
        return throwError(error);
      }),
      finalize(() => {
        this.waitService.cancelWaiting();
      }),
      map(() => items) // Transformar el resultado en el arreglo de items actualizado
    );
  }

}
